import { log } from 'log';
import { useEffect } from 'react';
import { prop, pick } from 'ramda';
import { useDispatch } from 'react-redux';
import { useUserSelector, useSportsbookSelector } from 'js/store/hooks';

import * as actions from '../store/actions';

export const useSportsbookBalance = () => {
    const dispatch = useDispatch();
    const { isLoggedIn, balance } = useUserSelector(pick(['isLoggedIn', 'balance']));
    const isAppInitialized = useSportsbookSelector(prop('isAppInitialized'));
    const balances = balance?.balances;

    useEffect(() => {
        if (isAppInitialized && isLoggedIn) {
            try {
                window.Sportsbook.sendMessage('GET_BALANCE').then((response) => dispatch(actions.updateBalances(response)));
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Get balance error', error);
            }
        }
    }, [dispatch, isAppInitialized, isLoggedIn]);

    useEffect(() => {
        if (isAppInitialized && isLoggedIn && balances) {
            try {
                const balanceMessage = {
                    ID: 32010,
                    data: {
                        balances: []
                    }
                };

                for (const balanceType in balances) {
                    balanceMessage.data.balances.push({
                        balanceType,
                        balance: balances[balanceType]
                    });
                }
                window.Sportsbook.sendMessage('OAPI_RESPONSE', balanceMessage);
            } catch (error) {
                log('log', '[SPORTSBOOK | Portal] Set balance error', error);
            }
        }
    }, [balances, dispatch, isAppInitialized, isLoggedIn]);
};
